import React, { useState } from "react";
import { Panel } from "primereact/panel";
import "./FAQ.css";

export default function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const togglePanel = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const faqs = [
    {
      header: "What is included in the Basic Plan?",
      content:
        "The Basic Plan includes a static 5-page website with responsive design, free domain, free hosting for 1 year, social media integration, Google Maps, and WhatsApp chat support — perfect for startups or personal portfolios.",
    },
    {
      header: "Can I upgrade to a higher plan later?",
      content:
        "Yes, absolutely! You can upgrade from Basic to Standard or Bonanza anytime. We’ll handle the transition smoothly without affecting your existing website or content.",
    },
    {
      header: "Do I get a business email with the Basic Plan?",
      content:
        "Business emails are included starting from the Standard Plan. The Basic Plan does not include domain-based email addresses.",
    },
    {
      header: "Will my website be mobile-friendly?",
      content:
        "Yes, all our plans include 100% mobile-responsive designs to ensure your website looks great on phones, tablets, and desktops.",
    },
    {
      header: "What kind of support do you offer?",
      content:
        "We offer email and WhatsApp support with every plan. Bonanza Plan customers also receive 24/7 system monitoring and priority support.",
    },
    {
      header: "How long will it take to build my website?",
      content:
        "Basic websites typically take 3–5 business days. Standard and Bonanza plans may take 7–15 days depending on customization and features.",
    },
    {
      header: "Will I be able to manage the website myself?",
      content:
        "Yes! For dynamic sites (Bonanza Plan), we include a user-friendly admin panel. For static sites, we offer maintenance services if needed.",
    },
    {
      header: "Is SEO included in all plans?",
      content:
        "Basic SEO setup is included in the Standard and Bonanza plans. The Bonanza Plan comes with an SEO-ready structure optimized for better visibility.",
    },
    {
      header: "Can I request custom features not listed in the plan?",
      content:
        "Yes, custom features like payment gateways, live chat, or booking systems can be added for an additional cost. Contact us to discuss your needs.",
    },
    {
      header: " What payment methods do you accept?",
      content:
        "We accept UPI, bank transfers, credit/debit cards, and online wallets. For Bonanza plans, part-payment options are also available.",
    },
  ];

  return (
    <>
      <div className="flex justify-content-center align-items-center faq-outer-container">
        <div className="w-full sm:w-11 md:w-9 lg:w-9 mb-4">
          <div
            className="mb-4 text-center Text-Gradient"
            style={{ fontFamily: "rockwell" }}>
            <h1 className="m-5">
              <b> Frequently Asked Questions</b>
            </h1>
          </div>
          <div
            className="space-y-2"
            style={{ backgroundColor: "white", fontFamily: "rockwell" }}>
            {faqs.map((faq, index) => (
              <Panel
                key={index}
                header={faq.header}
                toggleable
                collapsed={activeIndex !== index}
                onToggle={() => togglePanel(index)}
                className="faq-panel" // for background color
                headerClassName="faq-header" // for header text size
              >
                {faq.content}
              </Panel>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
